export default __webpack_public_path__ + "static/media/icon-download-white.6ad8a246.svg";